import { render } from "./ManualesUsuario.vue?vue&type=template&id=666458ca"
import script from "./ManualesUsuario.vue?vue&type=script&lang=js"
export * from "./ManualesUsuario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__